<div class="edit-sum-wrapper" (click)="showAutocomplete=true">
  @if (showAutocomplete) {
    <app-formula-input-picker
      (valueSelected)="itemSelected($event)"
      [source]="optionsList"
      min-chars="1"
      show-input-tag="showAutocomplete"
      select-value-of="value"
      match-formatted="true"
      no-match-found-text="No Match Found"
      placeholder="Start typing for item suggestions"
    ></app-formula-input-picker>
  }
</div>
